module.exports = __webpack_public_path__ + "static/media/sohananime'.855e625d.png";